import React from "react";
import { GetLightpointData } from "../hooks/middleware.js";
import { CountItems, SortItems, GetTopItems, CountTotal } from "../hooks/chartMethods.js";
import MapDistricts from "./MapDistricts.jsx";

const COLORS = ["#f76e24", "#ff9e59", "#ffb380", "#ffd1a3", "#ffe6cc"];

export default function TileTopManufacturers({ id }) {
  const { data, error } = GetLightpointData(id);

  const counts = CountItems(data, "locationdistrict");
  const sorted = SortItems(counts, "count");
  const finalData = GetTopItems(sorted, 3, "Others");
  const totalCount = CountTotal(finalData, "count");

  if (error) return <p>Error loading data.</p>;
  if (!finalData) return <p>Loading data...</p>;
  if (finalData.length === 0) return <p>No data found</p>;

  return (
    <div style={{ display: "flex", gap: "2rem", alignItems: "stretch" }}>
      {/* Table column */}
      <div style={{ minWidth: "200px" }}>
  {finalData.map((item, index) => (
    <div
      key={item.name}
      className="table-row"
      style={{
        display: "flex",
        alignItems: "center",
        height: "40px",
        marginBottom: "4px",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "12px",
          height: "12px",
          backgroundColor: COLORS[index % COLORS.length],
          marginRight: "0.5rem",
          borderRadius: "2px",
        }}
      ></span>

      <span
        style={{
          minWidth: "100px",
          maxWidth: "100px",
          display: "inline-block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={item.name} // shows full name on hover
      >
        {item.name}
      </span>

      <span style={{ minWidth: "80px", textAlign: "right" }}>
        {((item.count / totalCount) * 100).toFixed(1)}%
      </span>

      <span style={{ minWidth: "80px", textAlign: "right" }}>
        {Number(item.count).toLocaleString("en-US")}
      </span>
    </div>
  ))}
</div>

      <div style={{ flex: 1 }}>
        <MapDistricts id={id} tableData={finalData} />
      </div>
    </div>
  );
}
